export default __webpack_public_path__ + "static/media/wellgo_reviewer3.5bffd422.jpg";